import OperationalReportPage from './OperationalReportPage';
export default function GrnReconciliationReportPage(){return <OperationalReportPage kind="grn-reconciliation"/>;}
